import React from "react";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import ContractDocumentViewer from "./ContractDocumentViewer";

export default function ContractDocumentsPreviewDialog({
  open,
  onClose,
  contractLabel,
  loading,
  error,
  previewType,
  onPreviewTypeChange,
  contractUrl,
  sepaUrl,
  additionalDocs,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Pré-visualizar Documentos</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Contrato: {contractLabel || "-"}
          </Typography>

          <ContractDocumentViewer
            loading={loading}
            type={previewType}
            onTypeChange={onPreviewTypeChange}
            contractUrl={contractUrl}
            sepaUrl={sepaUrl}
            additionalDocs={additionalDocs}
            frameHeight={520}
          />

          {error ? <Alert severity="warning">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

